/**
 * "Clappers en licencia": total, % del universo y el botón que abre el gestor
 * (dialog). Auditoría 18/09/2026: D-Talk People y el Mapa del equipo tenían la
 * misma card copiada (Sol pidió "la misma card que D-Talk"); ahora es una.
 */
import { PauseCircle, Settings2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function LicenseCard({ count, pct, hint, manageLabel, onManage }: {
  count: number;
  /** % sobre el universo (ya redondeado). */
  pct: number;
  /** Aclaración del módulo ("No se les pide la conversación" / "Fuera del ciclo"). */
  hint: string;
  /** Sin `onManage` no hay botón (People sin permiso, o sin nadie en licencia). */
  manageLabel?: string;
  onManage?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Card>
      <CardContent className="py-4">
        <h3 className="mb-3 flex items-center gap-1.5 text-sm font-semibold">
          <PauseCircle className="h-4 w-4 text-muted-foreground" />
          {t('performance.dtalkpeoplemetrics.clappers_en_licencia')}
        </h3>
        <div className="space-y-1.5 text-sm">
          <div className="flex items-baseline justify-between">
            <span className="text-muted-foreground">{t('performance.dtalkpeoplemetrics.total_en_licencia')}</span>
            <span className="text-2xl font-bold tabular-nums">{count}</span>
          </div>
          <div className="flex items-baseline justify-between">
            <span className="text-muted-foreground">{t('performance.dtalkpeoplemetrics.del_total')}</span>
            <span><b>{pct}%</b></span>
          </div>
          <p className="text-xs text-muted-foreground">{hint}</p>
          {onManage && (
            <Button variant="outline" size="sm" className="mt-2 w-full gap-1.5" onClick={onManage}>
              <Settings2 className="h-4 w-4" />
              {manageLabel ?? t('performance.dtalkpeoplemetrics.gestionar_licencias')}
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
